import { animate, state, style, transition, trigger } from '@angular/animations';

export const slideInLeft = trigger('slideContent', [
    state('void', style({ transform: 'translate3d(100%, 0 , 0)' })),
    state('enter', style({ transform: 'translate3d(0, 0, 0)' })),
    state('leave', style({ transform: 'translate3d(100%, 0, 0)' })),
    transition('* => enter', [
        style({
            transform: 'scale3d(1, 1, 1) translate3d(108%, 0, 0)',
            transformOrigin: 'left center',
        }),
        animate(
            '500ms cubic-bezier(0.250, 0.460, 0.450, 0.940)',
            style({
                transform: 'scale3d(1, 1, 1) translate3d(0, 0, 0)',
                transformOrigin: 'left center',
            })
        ),
    ]),
    transition('* => leave', [
        style({ transform: 'translate3d(0, 0, 0)' }),
        animate(
            '300ms cubic-bezier(0.550, 0.085, 0.680, 0.530)',
            style({
                transform: 'translate3d(108%, 0, 0)',
            })
        ),
    ]),
]);

export const slideInTop = trigger('slideContent', [
    state('void', style({ transform: 'translate(0, -75%', opacity: 0.33 })),
    state('enter', style({ transform: 'translate(0, 0)', opacity: 1 })),
    state('leave', style({ transform: 'translate(0, -75%', opacity: 0.33 })),
    transition(
        '* => enter',
        [
            animate('300ms')
        ]
    ),
    transition(
        '* => leave',
        [
            animate('150ms')
        ]
    )
]);